import "@progress/kendo-ui/js/kendo.calendar";
import "@progress/kendo-ui/js/kendo.data";
import "@progress/kendo-ui/js/kendo.datepicker";
import "@progress/kendo-ui/js/kendo.listview";
import "@progress/kendo-ui/js/kendo.menu";
import "@progress/kendo-ui/js/kendo.panelbar";
import "@progress/kendo-ui/js/kendo.popup";
import "@progress/kendo-ui/js/kendo.selectable";
import "@progress/kendo-ui/js/kendo.tooltip";
import "@progress/kendo-ui/js/kendo.touch";
import "@progress/kendo-ui/js/kendo.treeview";
import "@progress/kendo-ui/js/kendo.userevents";
import * as ko from "knockout";
import "../../style/vendor/telerikReportViewer.css";
import "../../templates/telerikreportviewer.html";
import * as ReportData from "../data/reportData";
import "../vendor/telerikReportViewer.js";
import * as Global from "./global";
import * as UI from "./ui";

interface IReportViewerViewModel {
    emailAddress: KnockoutObservable<string>;
    emailAddresses: KnockoutObservableArray<string>;
    canEmailReport: KnockoutObservable<boolean>;
    errors?: KnockoutValidationErrors;
    emailReport: () => void;
    closeEmailModal: () => void;
    addEmail: () => void;
    removeEmail: (email: string) => void;
}

export class ReportViewer {
    private telerikReportViewer: any;
    private container: JQuery;
    private emailReportModal: JQuery;
    private viewModel: IReportViewerViewModel;

    private emailReportCommand: any = {
        enabled: () => {
            return this.viewModel.canEmailReport();
        },
        checked: () => false,
        exec: () => {
            this.emailReportModal.modal("show");
        },
    };

    constructor() {

        this.viewModel = {
            emailAddress: ko.observable("").extend({ required: true, email: true }),
            emailAddresses: ko.observableArray(),
            canEmailReport: ko.observable(false),
            addEmail: () => {
                if (this.viewModel.errors && this.viewModel.errors().length > 0) {
                    this.viewModel.errors.showAllMessages();
                    return;
                }

                for (const email of this.viewModel.emailAddresses()) {
                    if (email.toLowerCase() === this.viewModel.emailAddress().toLowerCase()) {
                        return;
                    }
                }

                this.viewModel.emailAddresses.push(this.viewModel.emailAddress());
                this.viewModel.emailAddress("");
                this.viewModel.emailAddress.isModified(false);
            },
            removeEmail: (email: string) => {
                this.viewModel.emailAddresses.remove(email);
            },
            closeEmailModal: () => {
                this.emailReportModal.modal("hide");
                this.viewModel.emailAddress("");
                this.viewModel.emailAddress.isModified(false);
                this.viewModel.emailAddresses([]);
            },
            emailReport: () => {

                if (this.viewModel.emailAddresses().length === 0) { return; }

                const reportSource = this.telerikReportViewer.reportSource();

                const request: ReportData.IEmailReportRequest = {
                    EmailAddresses: this.viewModel.emailAddresses(),
                    ReportID: reportSource.report,
                    Parameters: [],
                };

                for (const key in reportSource.parameters) {
                    if (reportSource.parameters.hasOwnProperty(key)) {
                        request.Parameters.push({ Name: key, Value: reportSource.parameters[key] });
                    }
                }

                const waitIndicator = UI.showWaitIndicator(this.container);

                ReportData.EmailReport(request)
                    .done((response) => {
                        if (response.Success) {
                            this.emailReportModal.modal("hide");
                            this.viewModel.emailAddress("");
                            this.viewModel.emailAddresses([]);
                            this.viewModel.emailAddress.isModified(false);
                            UI.showNotificationMessage("Report Emailed", UI.messageTypeValues.success);
                        } else {
                            UI.showErrorMessage(response.ErrorMessages);
                        }
                    })
                    .always(() => {
                        UI.hideWaitIndicator(this.container, waitIndicator);
                    });
            },
        };

        this.viewModel.errors = ko.validation.group(this.viewModel, { deep: true });
    }

    public render(container: JQuery): JQueryDeferred<any> {
        const deferred = $.Deferred();
        const app = Global.app();
        this.container = container;

        app.templates().render("reportviewer", "template_reportviewer", this.container)
            .done(() => {
                ko.applyBindings(this.viewModel, this.container[0]);

                this.emailReportModal = $(".emailReportModal");

                this.telerikReportViewer = this.container.find(".telerikReportViewer").telerik_ReportViewer({
                    authenticationToken: app.reportToken,
                    scaleMode: "FIT_PAGE_WIDTH",
                    serviceUrl: app.reportingWebServiceBaseURL + "/api/telerikreports",
                    templateUrl: "/templates/telerikreportviewer.html",
                    renderingBegin: () => {
                        $("#emailReportItem").addClass("k-state-disabled");
                        this.viewModel.canEmailReport(false);
                    },
                    pageReady: () => {
                        $("#emailReportItem").removeClass("k-state-disabled");
                        this.viewModel.canEmailReport(true);
                    },
                },
                ).data("telerik_ReportViewer");

                this.telerikReportViewer.commands.emailReport = this.emailReportCommand;
                deferred.resolve();
            });

        return deferred;
    }

    public loadReport(reportID: string | number, params?: any) {
        this.telerikReportViewer.reportSource({
            report: reportID,
            parameters: params,
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/reportViewer.ts